package com.patronat.top.ui.molecules.actions

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.widthIn
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.theme.AppIcons

@Composable
fun TopActionRow(
    onUploadClick: () -> Unit,
    onAddClick: () -> Unit,
    modifier: Modifier = Modifier,
    uploadText: String = "Завантажити файлом",
    addText: String = "Додати послугу",
    uploadIcon: Painter? = null,
    addIcon: Painter? = AppIcons.Plus,
    uploadEnabled: Boolean = true,
    addEnabled: Boolean = true
) {
    BoxWithConstraints(modifier = modifier.fillMaxWidth()) {
        val isCompact = maxWidth < 560.dp

        if (isCompact) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                AppButton(
                    text = uploadText,
                    onClick = onUploadClick,
                    type = ButtonType.BrownOutline,
                    enabled = uploadEnabled,
                    leadingIcon = uploadIcon,
                    modifier = Modifier
                        .fillMaxWidth()
                        .widthIn(min = 180.dp)
                )

                AppButton(
                    text = addText,
                    onClick = onAddClick,
                    type = ButtonType.BrownFilled,
                    enabled = addEnabled,
                    leadingIcon = addIcon,
                    modifier = Modifier
                        .fillMaxWidth()
                        .widthIn(min = 180.dp)
                )
            }
        } else {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(12.dp, Alignment.End)
            ) {
                AppButton(
                    text = uploadText,
                    onClick = onUploadClick,
                    type = ButtonType.BrownOutline,
                    enabled = uploadEnabled,
                    leadingIcon = uploadIcon,
                    modifier = Modifier.widthIn(min = 220.dp)
                )

                AppButton(
                    text = addText,
                    onClick = onAddClick,
                    type = ButtonType.BrownFilled,
                    enabled = addEnabled,
                    leadingIcon = addIcon,
                    modifier = Modifier.widthIn(min = 180.dp)
                )
            }
        }
    }
}
